/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbBusyIndicator } from "absdk/commons/ui/misc/AbBusyIndicator";
import * as React from "react";
export class ExpressionLoading extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(AbBusyIndicator, {
      message: AbReactResources.message_loading()
    });
  }
}
//# sourceMappingURL=ExpressionLoading.js.map
